<script>
    import { langTextStore } from "../store/langtexts";

    import { inputVariableStore } from "../store/inputVariables.js";
    import { outputVariableStore } from "../store/outputVariables.js";
    import IconDelete from "../Vectors/delete.svelte";
    import IconPlus from "../Vectors/pluscirkel.svelte";
    import { factoryStore } from "../store/factories";
    import { createEventDispatcher, tick } from "svelte";

    import InputVarScenario from "../SharedComponents/InputVarScenario.svelte";

    let showScenarioTool = false;
    let showAddTool = false;
    const dispatch = createEventDispatcher();

    function addScenarioVar(scenarioVarName) {
        $inputVariableStore.scenarioConfiguration.scenarioVars = [
            ...$inputVariableStore.scenarioConfiguration.scenarioVars,
            scenarioVarName,
        ];
        window.setTimeout(() => bubbleChange(), 100);
    }
    function removeScenarioVar(scenarioVarName) {
        $inputVariableStore.scenarioConfiguration.scenarioVars =
            $inputVariableStore.scenarioConfiguration.scenarioVars.filter(
                (s) => {
                    return s != scenarioVarName;
                }
            );

        $inputVariableStore.scenarioConfiguration.scenarios.forEach((s) => {
            delete $outputVariableStore.scenarioConfiguration
                .calculatedScenarios[s][scenarioVarName];

            delete $inputVariableStore.scenarioConfiguration
                .calculatedScenarios[s][scenarioVarName];
        });
        bubbleChange();
    }

    let selectedScenarioVar = "";
    function addSelectedScenarioVar() {
        if (selectedScenarioVar == "") {
            snackbar(
                "error",
                $langTextStore.getText("general-label-error-choose-a-var")
            );
            return;
        }
        addScenarioVar(selectedScenarioVar);
        selectedScenarioVar = "";
        showAddTool = false;
        bubbleChange();
    }

    function bubbleChange() {
        try {
            dispatch("change", null);
        } catch (e) {}
    }

    var prevScenarioList = [
        ...$inputVariableStore.scenarioConfiguration.scenarios,
    ];

    let timer;

    function showHelp() {
        showScenarioHelp = true;
    }
    var cnt = 0;

    function compareVariable(a, b) {
        return a.name > b.name ? 1 : -1;
    }
    export let showScenarioHelp = false;
    let sort = true;
    $: addableVariables = $factoryStore.currentCalculator.variables.filter(
        (v) => {
            return (
                !v.readOnly &&
                !v.isFunction &&
                !(v.varNameKey.toLowerCase().indexOf("grade") == 0) &&
                !$inputVariableStore.scenarioConfiguration.scenarioVars.some(
                    (sv) => sv == v.varNameKey
                )
            );
        }
    );
    $: filteredTranslatedAddableVariables = addableVariables
        .filter((v) => !v.isWageDistributionVar && v.includeInScenarioManager)
        .map((v) => {
            return {
                varNameKey: v.varNameKey,
                name: $langTextStore
                    .getText("variable-" + v.varNameKey + "-help-title")
                    .trim(),
            };
        });
    $: getTexts(addableVariables);
    function getTexts(addableVariables) {
        for (var v in addableVariables) {
            var variable = addableVariables[v];
            $langTextStore.getText(
                "variable-" + variable.varNameKey + "-help-title"
            );
        }
    }
</script>

<div class="col-5 section vh-90">
    <div id="scenario-variables" class="section__container bg-gray-8 h-100 pane">
        <h2 class="highlight">
            {$langTextStore.getText("general-header-edit-your-scenarios")}
        </h2>

        <div class="w-100 mb-3 mt-2 mb-lg-0">&nbsp;</div>
        <!-- <h3 class="font-primary font-weight-normal">
            {$langTextStore.getText("general-header-variables")}
        </h3> -->

        <div class="row g-2  mt-1 pb-0 variable">
            <h4 class="col-4 mb-0 mt-0  text-gray-6 ">
                {$langTextStore.getText("legal-min-wage")}
            </h4>
            <h4 class="col-4 mb-0 mt-0  text-gray-6 ">
                {$langTextStore.getText("target-wage")}
            </h4>
            <h4 class="col-4 mb-0 mt-0  text-gray-6 ">
                {$langTextStore.getText("alternate")}
            </h4>
        </div>
        <hr class="mb-3 mt-3" />
        {#each $inputVariableStore.scenarioConfiguration.scenarioVars as scenarioVar}
            <div class="row g-2  mt-0 pb-0 variable">
                <div class="col-8 text-gray-6 mb-2 text-small">
                    {$langTextStore.getText(
                        "variable-" + scenarioVar + "-help-title"
                    )}
                </div>
                <div
                    class="col-4 text-right c-pointer"
                    on:click={removeScenarioVar(scenarioVar)}
                >
                    <IconDelete
                        icontitle={$langTextStore.getText(
                            "general-label-delete-variable"
                        )}
                    />
                </div>
                <div class="col-4 mt-0">
                    <InputVarScenario
                        variable={$factoryStore.currentCalculator.variables.find(
                            (v) => v.varNameKey == scenarioVar
                        )}
                        bind:value={$inputVariableStore.scenarioConfiguration
                            .calculatedScenarios["base"][scenarioVar]}
                        readonly={true}
                    />
                </div>
                {#each $inputVariableStore.scenarioConfiguration.scenarios as scenario}
                    <div class="col-4 mt-0">
                        <InputVarScenario
                            readonly={false}
                            on:keyup={bubbleChange}
                            on:change={bubbleChange}
                            variable={$factoryStore.currentCalculator.variables.find(
                                (v) => v.varNameKey == scenarioVar
                            )}
                            bind:value={$inputVariableStore
                                .scenarioConfiguration.scenarioVarValues[
                                scenario
                            ][scenarioVar]}
                        />
                    </div>
                {/each}
            </div>
        {/each}
        <hr class="mb-3 mt-3" />
        <div class="row g-1 mt-4">
            {#if showAddTool == true}
                <hr />
                <select
                    class="col-12 col-md-7 col-lg-8"
                    bind:value={selectedScenarioVar}
                >
                    <option value=""
                        >{$langTextStore.getText(
                            "general-label-choose"
                        )}</option
                    >
                    {#each filteredTranslatedAddableVariables.sort(compareVariable) as variable}
                        <option value={variable.varNameKey}
                            >{variable.name}</option
                        >
                    {/each}
                </select>
                <div class="col-12 offset-md-1 col-md-4 col-lg-3">
                    <span class="btn" on:click={addSelectedScenarioVar}>
                        {$langTextStore.getText("general-label-add")}
                    </span>
                </div>
            {:else}
                <div
                    class="text-gray-6 c-pointer "
                    on:click={() => {
                        showAddTool = true;
                    }}
                >
                    <span class="text-primary me-3 ms-3"
                        ><IconPlus
                            icontitle={$langTextStore.getText(
                                "general-label-add-variable"
                            )}
                        /></span
                    ><span class="d-inline-block"
                        >{$langTextStore.getText(
                            "general-label-add-variable"
                        )}</span
                    >
                </div>
            {/if}
        </div>
    </div>
</div>
